import { createStore, combineReducers } from 'redux';
import userReducer from './reducers/user';
import metaReducer from './reducers/meta';
import locationsReducer from './reducers/locations';

const reducers = combineReducers({
    user: userReducer,
    meta: metaReducer,
    location: locationsReducer
});

const Store = createStore(reducers);

export default Store;


// WEBPACK FOOTER //
// ./src/store.js